import React from 'react';
import Footer from './common/Footer';

const CancellationPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-900 relative overflow-hidden">
  

      <div className="flex-grow flex flex-col items-center py-12 px-4 sm:px-6 lg:px-8">
        {/* Logo Section */}
        <div className="w-full max-w-lg mb-8">
          <div className="flex flex-col items-center relative z-10">
            <img
              src="/images/imr-logo.png"
              alt="IMR Logo"
              className="h-32 w-auto mb-4"
            />
            <h1 className="text-center text-2xl font-bold text-yellow-500">
              DEFENCE INDUSTRY DIRECTORY
            </h1>
          </div>
        </div>

        {/* Cancellation Policy Content */}
        <div className="w-full max-w-4xl relative z-10">
          <div className="bg-gray-800/90 shadow-lg rounded-lg p-8 border border-gray-700 backdrop-blur-sm text-gray-300">
            <h2 className="text-2xl font-bold text-yellow-500 mb-6">Cancellations and Refunds Policy</h2>
            <p className="text-sm mb-4">Effective Date: 1 June 2025</p>
            
            <p className="mb-6">
              This Cancellations and Refunds Policy applies to all users of directory.defencepartners.in, 
              including both Annual Subscribers and Directory Participants (companies listing their data and offerings).
            </p>

            <div className="space-y-6">
              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">1. General Policy</h3>
                <ul className="list-disc pl-6 space-y-1">
                  <li>
                    All payments made to directory.defencepartners.in are <span className="font-bold">non-refundable</span>. 
                    By completing a payment, you acknowledge and accept this no-refund policy.
                  </li>
                  <li>
                    We do not issue partial or full refunds for any reason, including but not limited to early cancellation, 
                    unused subscription time, or dissatisfaction with the service or listing.
                  </li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">2. Annual Subscribers</h3>
                <ul className="list-disc pl-6 space-y-1">
                  <li>
                    You may cancel your subscription at any time. Cancellation will prevent future renewals, but <span className="font-bold">no refunds</span> will 
                    be issued for payments already made or for any unused portion of your subscription term.
                  </li>
                  <li>Access to the directory will remain active until the end of the paid subscription period.</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">3. Directory Participants (Companies)</h3>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Payments for listing, promoting, or updating company data are non-refundable.</li>
                  <li>If you choose to remove your company listing or discontinue participation, no refunds will be issued for any fees paid.</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">4. Subscription Renewal and Cancellation</h3>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Subscriptions renew automatically at the end of each billing cycle unless cancelled before the renewal date.</li>
                  <li>To avoid renewal charges, you must cancel your subscription before the renewal date. No refunds will be issued for failure to cancel in time.</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">5. Exceptional Circumstances</h3>
                <ul className="list-disc pl-6 space-y-1">
                  <li>
                    Refunds will only be considered if required by applicable law or in the rare event of a proven technical error 
                    that prevented access to the paid service, and only at our sole discretion.
                  </li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">6. Contact</h3>
                <p>For questions regarding this policy, please contact us at directory@defencepartners.in.</p>
              </section>

              <p className="mt-8 text-sm text-gray-400">
                By making a payment or using our services, you confirm that you have read, understood, and agreed to this 
                Cancellations and Refunds Policy.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CancellationPolicy;
